<i18n locale="en">
{
  "title": "Careers isn't available on your plan",
  "body": "The website job board is included on a higher plan. Upgrade to post open roles and collect applications.",
  "upgrade": "Upgrade plan"
}
</i18n>
<template>
  <div
    class="careers-gate-placeholder flex flex-col items-center justify-center gap-3 py-16 text-center"
    data-testid="careers-gate-placeholder"
  >
    <span class="careers-gate-placeholder__icon">
      <Lock :size="28" />
    </span>
    <OwnType :text="t('title')" variant="title-large" />
    <OwnType
      class="max-w-[420px]"
      :text="t('body')"
      variant="paragraph-regular"
      color="secondary"
    />
    <!-- Self-checkout/upgrade is owned by another team; this CTA's destination
         is wired in a follow-up PR. Intentionally inert for now. -->
    <OwnButton
      :text="t('upgrade')"
      variant="primary"
      data-testid="careers-gate-upgrade-button"
    />
  </div>
</template>

<script lang="ts" setup>
import { Lock } from '@owner/icons-vue/Lock'
import { useI18n } from 'vue-i18n'

import { OwnButton } from '@/ui/OwnButton'
import { OwnType } from '@/ui/OwnType'

const { t } = useI18n()
</script>

<style lang="scss" scoped>
.careers-gate-placeholder {
  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    color: var(--text-color-secondary);
    background-color: var(--background-active);
  }
}
</style>
